import { CountLinkParams } from "../../typings";

export const getCountLinkParams = (props): CountLinkParams => {
    return {
        showFavorites: props.isFavoritesEnabled,
        handlers: props.handlers,
        isInFavorites: props.event.isInFavorites,
        linkUrl: props.event.linkUrl,
        count: props.event.marketLinesCount
    }
}